export default __webpack_public_path__ + "static/media/cert-general-staff-a-cpttm-sc.c423ca2d.jpg";